export const AbFeatureNames = {
  NUMBER_POOL: 'NUMBER_POOL',
  SIMONLYPLUS_UPSELL_DESIGN: 'SIMONLYPLUS_UPSELL_DESIGN',
  PX_ADDONS: 'PX_ADDONS',
  ESHOP_OTP_API: 'ESHOP_OTP_API',
  LINE_SELECTION: 'LINE_SELECTION',
  ESHOP_RECAPTCHA: 'ESHOP_RECAPTCHA',
  DELETE_PENDING_ORDER_FOR_NEW_FLOW: 'DELETE_PENDING_ORDER_FOR_NEW_FLOW'
};
